import { Controller, useFormContext } from 'react-hook-form';
import { Grid, TextField } from '@material-ui/core';
import React, { FC } from 'react';
import { Skeleton } from '@material-ui/lab';
import { PostInterventionOrderBody } from 'src/interfaces/api/InterventionOrder';

interface Props {
  loading?: boolean;
  readOnly?: boolean;
}

const AddressFields: FC<Props> = ({ loading, readOnly }) => {
  const { control } = useFormContext<PostInterventionOrderBody>();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Controller
          name='address'
          control={control}
          rules={{ required: { value: !readOnly, message: 'Le champ est requis' } }}
          render={({ field: { value, ...others }, fieldState: { error } }) =>
            loading ? (
              <Skeleton height={56} />
            ) : (
              <TextField
                {...others}
                value={value || ''}
                label='Adresse'
                variant='outlined'
                fullWidth
                disabled={readOnly}
                error={undefined !== error}
                helperText={error?.message}
              />
            )
          }
        />
      </Grid>

      <Grid item xs={7} sm={8}>
        <Controller
          name='city'
          control={control}
          rules={{ required: { value: !readOnly, message: 'Le champ est requis' } }}
          render={({ field: { value, ...others }, fieldState: { error } }) =>
            loading ? (
              <Skeleton height={56} />
            ) : (
              <TextField
                {...others}
                value={value || ''}
                label='Ville'
                variant='outlined'
                fullWidth
                disabled={readOnly}
                error={undefined !== error}
                helperText={error?.message}
              />
            )
          }
        />
      </Grid>

      <Grid item xs={5} sm={4}>
        <Controller
          name='postalCode'
          control={control}
          rules={{ required: { value: !readOnly, message: 'Le champ est requis' } }}
          render={({ field: { value, ...others }, fieldState: { error } }) =>
            loading ? (
              <Skeleton height={56} />
            ) : (
              <TextField
                {...others}
                value={value || ''}
                label='Code postal'
                variant='outlined'
                fullWidth
                disabled={readOnly}
                error={undefined !== error}
                helperText={error?.message}
              />
            )
          }
        />
      </Grid>
    </Grid>
  );
};

export default AddressFields;
